module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-4 columns-withpadding"
  }, [_c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "section has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "https://pisciculturaglobal.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": "Piscicultura Global"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body",
    attrs: {
      "id": "form-register"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register()
      }
    }
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "notification is-info",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4|verify_username'),
      expression: "'required|min:4|verify_username'"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "placeholder": "Nombre de Usuario",
      "autocomplete": "off",
      "name": "username",
      "data-vv-as": "nombre de usuario"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.wait_user && _vm.errors.has('username')),
      expression: "!wait_user && errors.has('username')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wait_user),
      expression: "wait_user"
    }],
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.username && _vm.fields.username.dirty && !_vm.wait_user && !_vm.errors.has('username')),
      expression: "fields.username && fields.username.dirty && !wait_user && !errors.has('username')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('first_name')
    },
    attrs: {
      "type": "text",
      "placeholder": "Nombres",
      "autocomplete": "off",
      "name": "first_name",
      "data-vv-as": "nombres"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('first_name')),
      expression: "errors.has('first_name')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.first_name && _vm.fields.first_name.dirty && !_vm.errors.has('first_name')),
      expression: "fields.first_name && fields.first_name.dirty && !errors.has('first_name')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('first_name')),
      expression: "errors.has('first_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('first_name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('last_name')
    },
    attrs: {
      "type": "text",
      "placeholder": "Apellidos",
      "autocomplete": "off",
      "name": "last_name",
      "data-vv-as": "apellidos"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('last_name')),
      expression: "errors.has('last_name')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.last_name && _vm.fields.last_name.dirty && !_vm.errors.has('last_name')),
      expression: "fields.last_name && fields.last_name.dirty && !errors.has('last_name')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('last_name')),
      expression: "errors.has('last_name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('last_name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|verify_email'),
      expression: "'required|email|verify_email'"
    }],
    staticClass: "input email-input",
    class: {
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "Correo Electrónico",
      "autocomplete": "off",
      "name": "email",
      "data-vv-as": "correo electrónico"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.email && _vm.fields.email.dirty && !_vm.errors.has('email')),
      expression: "fields.email && fields.email.dirty && !errors.has('email')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:12'),
      expression: "'required|min:6|max:12'"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "placeholder": "●●●●●●●",
      "autocomplete": "off",
      "name": "password",
      "data-vv-as": "contraseña"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.password && _vm.fields.password.dirty && !_vm.errors.has('password')),
      expression: "fields.password && fields.password.dirty && !errors.has('password')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.repassword),
      expression: "user.repassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('repassword')
    },
    attrs: {
      "type": "password",
      "placeholder": "●●●●●●●",
      "autocomplete": "off",
      "name": "repassword",
      "data-vv-as": "repetir contraseña"
    },
    domProps: {
      "value": (_vm.user.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "repassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repassword')),
      expression: "errors.has('repassword')"
    }],
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.repassword && _vm.fields.repassword.dirty && !_vm.errors.has('repassword')),
      expression: "fields.repassword && fields.repassword.dirty && !errors.has('repassword')"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repassword')),
      expression: "errors.has('repassword')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('repassword')))])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "section forgot-password"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Iniciar Sesión")])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8 is-hidden-mobile hero-banner columns-withpadding",
    attrs: {
      "id": "image-background"
    }
  }, [_c('section', {
    staticClass: "hero is-fullheight is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Registrate")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "title is-3"
  }, [_vm._v("Accede a todos nuestros beneficios")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control login"
  }, [_c('button', {
    staticClass: "button is-success is-outlined is-large is-fullwidth",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Registrar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-647575d0","hasScoped":true}!./src/pages/register/template.html
// module id = 416
// module chunks = 1